<!--
 * @Author: your name
 * @Date: 2020-06-18 10:33:22
 * @LastEditTime: 2020-06-28 22:49:40
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /egg-node/Users/yangdeng/Desktop/work/neizhen2.1.0/neizhen-web/src/components/common/previewFile.vue
--> 
<template>
  <el-dialog
    class="previewFile_modal"
    style="border:1px solid #E6E6E6;margin:0 1px;font-size:12px;"
    :title="previewFileData.data && previewFileData.data.fileName"
    :visible.sync="previewFileData.state"
    width="100%"
    height="100%"
    :fullscreen="true"
    :before-close="handleClose"
  >
    <div
      class="form"
      id="form"
      v-loading="loading"
      v-if="
        previewFileData.state &&
          typeArray.indexOf(previewFileData.data.fileSuffix) < 0
      "
    >
      <div id="iframeEditor"></div>
    </div>
    <editor
      v-loading="loading"
      v-if="
        previewFileData.state &&
          typeArray.indexOf(previewFileData.data.fileSuffix) > -1
      "
      height="100%"
      width="100%"
      ref="editor"
      :content="content"
      v-model="content"
      :options="{
        readOnly: true,
        enableBasicAutocompletion: true,
        enableSnippets: true,
        enableLiveAutocompletion: true,
        tabSize: 2,
        fontSize: 16,
        showPrintMargin: false //去除编辑器里的竖线
      }"
      :lang="'html'"
      theme="chrome"
      @init="editorInit"
    >
    </editor>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { previewFiles, previewTxtFiles ,getPreviewTxtFiles} from "@/api/file/files";

export default {
  name: "previewFile",
  data() {
    return {
      configData: null,
      docEditor: null,
      loading: false,
      typeArray: ["html", "txt"],
      content: ""
    };
  },
  computed: {
    ...mapGetters(["previewFileData"])
  },
  watch: {
    previewFileData: {
      handler(newVal, oldVal) {
        if (newVal && newVal.state) {
          this.getFileConfig();
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {},
  methods: {
    handleClose() {
      this.content = "";
      this.$store.commit("setPreviewFileData", {
        data: this.previewFileData.data,
        state: false
      });
    },
    getFileConfig() {
        console.log(44444,this.previewFileData.data.fileSuffix);
        this.loading = true;
      if (this.typeArray.indexOf(this.previewFileData.data.fileSuffix) < 0) {
        previewFiles(
          this.previewFileData.data.previewPath,
          this.previewFileData.data.fileId
        )
          .then(res => {
            this.loading = false;
            if (res.data.code == 0) {
              this.configData = res.data.data;
              this.appendScript();
            } else {
              this.$notify.closeAll();
              this.$notify.error({
                title: "错误",
                message: `预览出错,请稍后重试,${res.data.msg}`
              });
              this.handleClose();
            }
          })
          .catch(error => {
            this.$notify.closeAll();
            this.$notify.error({
              title: "错误",
              message: `预览出错,请稍后重试,${error.msg}`
            });
            this.handleClose();
          });
      } else {
        // getPreviewTxtFiles(
        //   this.previewFileData.data.previewPath,
        //   this.previewFileData.data.fileId
        // )
        //   .then(res => {
        //     this.loading = false;
        //     this.content=res.data;
        //   })
        //   .catch(error => {
        //     this.$notify.closeAll();
        //     this.$notify.error({
        //       title: "错误",
        //       message: `预览出错,请稍后重试,${error.msg}`
        //     });
        //     this.handleClose();
        //   });
        previewTxtFiles(
          this.previewFileData.data.previewPath,
          this.previewFileData.data.fileId
        )
          .then(res => {
            this.loading = false;
            if (res.status == 200) {
              if (res.data.code === 1) {
                this.$notify.closeAll();
                this.$notify.error({
                  title: "错误",
                  message: `预览出错,请稍后重试,${res.data.msg}`
                });
                this.handleClose();
              } else {
                this.readFileData(
                  res.data.presignedUrl,
                  res.data.originalFileName,
                  res.data.charset
                );
              }
            } else {
              this.$notify.closeAll();
              this.$notify.error({
                title: "错误",
                message: `预览出错,请稍后重试,${res.data.msg}`
              });
              this.handleClose();
            }
          })
          .catch(error => {
            this.$notify.closeAll();
            this.$notify.error({
              title: "错误",
              message: `预览出错,请稍后重试,${error.msg}`
            });
            this.handleClose();
          });
      }
    },
    readFileData(url, name,charset) {
      var x = new XMLHttpRequest();
      x.open("GET", url, true);
      x.responseType = "blob";
      x.onload = e => {
        this.loading = false;
        let encoding = "utf-8";
        var reader = new FileReader();
       reader.onload = event => {
          // 读取完毕后输出结果
          this.content = event.target.result;
        };
        if (this.previewFileData.data.fileSuffix === "txt") {
            let blob = new Blob([e.target.result], {type: 'text/html'});
            /*this.isUtf8(blob).then(res => {
              console.log(777, res);
              encoding = res ? "gb2312" : "utf-8";
              reader.readAsText(x.response, encoding);
            });*/
            reader.readAsText(x.response, charset);
          } else {
            reader.readAsText(x.response, charset);
          }
         // reader.readAsText(x.response, charset);
      };
      x.send();
    },
    /**
     * @description: 二进制形式读取txt文件 并判断其是否为utf-8
     * @param {type}
     * @return:
     */
    readFile(file) {
        console.log(file)
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = function(evt) {
          resolve(evt.target.result);
        };
        reader.readAsArrayBuffer(file);
      });
    },

    async isUtf8(file) {
      let res = await this.readFile(file);
      console.log(res)
      let firstCode = new Uint8Array(res)[0];
      return firstCode >= 33 && firstCode <= 126;
    },
    editorInit() {
      require(["emmet/emmet"], function(data) {
        // this is huge. so require it async is better
        window.emmet = data.emmet;
      });
      require("brace/theme/chrome");
      require("brace/ext/language_tools"); //language extension prerequsite...
      require("brace/mode/html");
      require("brace/mode/json");
      require("brace/snippets/json");
      require("brace/snippets/html");
      this.$refs.editor.editor.setShowFoldWidgets(true);
    },
    appendScript() {
      // window.addEventListener("touchmove", { passive: false });
      var al = document.getElementsByTagName("script");
      var joine = [];
      for (var i = 0; i < al.length; i++) {
        joine.push(al[i].getAttribute("src"));
      }
      var ajoine = joine.join(",");
      if (ajoine.indexOf(this.configData.api) < 0) {
        // 创建script标签，引入外部文件
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.src = this.configData.api;
        document.getElementsByTagName("head")[0].appendChild(script);
        script.onload = script.onreadystatechange = () => {
          if (
            !this.readyState ||
            this.readyState == "loaded" ||
            this.readyState == "complete"
          ) {
            this.сonnectEditor();
          }
          script.onload = script.onreadystatechange = null;
        };
      } else {
        this.сonnectEditor();
      }
    },
    innerAlert(message) {
      if (console && console.log) console.log(message);
    },

    onReady() {
      innerAlert("Document editor ready");
    },

    onDocumentStateChange(event) {
      var title = document.title.replace(/\*$/g, "");
      document.title = title + (event.data ? "*" : "");
    },

    onRequestEditRights() {
      location.href = location.href.replace(RegExp("mode=view&?", "i"), "");
    },

    onError(event) {
      console.log(event);
      if (event) innerAlert(event.data);
    },

    onOutdatedVersion(event) {
      location.reload(true);
    },
    сonnectEditor() {
      var config = this.configData.config;

      this.docEditor = new DocsAPI.DocEditor("iframeEditor", config);
    }
  }
};
</script>

<style scoped>
.form {
  height: 100%;
}

div {
  margin: 0;
  padding: 0;
}
.ace-container {
  height: 100%;
}
</style>
